// src/modules/Main/Main.routes.js
import React from "react";
import MainPage from "./pages/MainPage";
import PatientInfoPage from "./pages/PatientInfoPage";

export const mainRoutes = [
  {
    path: "/Main",
    element: <MainPage />,
  },
  {
    path: "/patient-info/:cipId",
    element: <PatientInfoPage />,
  },
];
